var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPortrait
    ? _c(
        "div",
        {
          class: _vm.isLogin ? "avatar-btn-no-background" : "avatar-btn",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onAvatarClick.apply(null, arguments)
            },
          },
        },
        [
          _c("i-avatar", {
            ref: "avatar",
            attrs: {
              role: "button",
              url: _vm.avatarUrl,
              "login-state": _vm.isLogin,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isLogin && !_vm.isMobile(),
                  expression: "!isLogin && !isMobile()",
                },
              ],
              staticClass: "avatar-btn-text",
            },
            [_vm._v(_vm._s(_vm.$t("general.login")))]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDropdownListShow,
                  expression: "isDropdownListShow",
                },
              ],
              staticClass: "dropdown-list",
              class: _vm.dropdownPosition,
            },
            [
              _vm._l(
                _vm.dropdownList.filter((item) => item.group === "personal"),
                function (item) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !item.hidden,
                          expression: "!item.hidden",
                        },
                      ],
                      key: item.name,
                      staticClass: "dropdown-list__item",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onDropdownItemClick(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "svg-area" },
                        [
                          _c("svg-icon", {
                            staticClass: "svg-icon",
                            attrs: { name: item.name, color: "#FFF" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.text))]),
                      _vm._v(" "),
                      item.isNew
                        ? _c("span", { staticClass: "new-feature" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("general.new")) +
                                "\n      "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }
              ),
              _vm._v(" "),
              _c("div", { staticClass: "menu-group-last-item-line" }),
              _vm._v(" "),
              _vm._l(
                _vm.dropdownList.filter((item) => item.group === "logout"),
                function (item) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !item.hidden,
                          expression: "!item.hidden",
                        },
                      ],
                      key: item.name,
                      staticClass: "dropdown-list__item",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onDropdownItemClick(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "svg-area" },
                        [
                          _c("svg-icon", {
                            staticClass: "svg-icon",
                            attrs: { name: item.name, color: "#FFF" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.text))]),
                      _vm._v(" "),
                      item.isNew
                        ? _c("span", { staticClass: "new-feature" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("general.new")) +
                                "\n      "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }
              ),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }